import { Type } from 'class-transformer';
import { Company } from './Company';
import { Address } from '@/modules/backend/Entities/Address';
import { Provider } from '@/modules/backend/Entities/Provider';
import { Location as RouterLocation } from 'vue-router/types/router';

export class Building {
  private readonly id!: number;

  @Type(() => Address)
  private readonly address!: Address;

  @Type(() => Company)
  private readonly company!: Company;

  @Type(() => Provider)
  private readonly providers!: Provider[];

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.getAddress().displayName;
  }

  public getFullAddress(): string {
    return this.getAddress().getFull();
  }

  public getCompoundId(): number {
    return Number(this.getCompany().getId().toString() + this.getId().toFixed());
  }

  public getAddress(): Address {
    return this.address;
  }

  public getCompany(): Company {
    return this.company;
  }

  public getProviders(): Provider[] {
    return this.providers || [];
  }

  public hasProvidersById(...providerIds: number[]): boolean {
    return providerIds
      .every((id: number) => this.providers
        .map((provider) => provider.getId())
        .includes(id));
  }

  public getRouteLocation(): RouterLocation {
    return {
      name: 'dashboard.building.locations',
      params: {
        buildingId: String(this.getId()),
      },
    };
  }
}
